import PropTypes from 'prop-types'
import { DoorOpen } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import { APP_COLORS } from '../../helpers/constants'

const DoorUnlocked = ({ onDone }) => {
  const { t } = useTranslation(['package-room'])
  return (
    <div className="package-room__content package-room__content--full">
      <div className="package-room__access-container package-room__access-container--unlocked">
        <div className="package-room__icon package-room__icon--success">
          <DoorOpen size={64} color={APP_COLORS.black300} weight="regular" />
        </div>

        <h2 className="package-room__title package-room__title--unlocked">
          {t('package-room:doorUnlocked.title')}
        </h2>

        <div className="package-room__unlocked-message">
          <p>{t('package-room:doorUnlocked.message')}</p>
        </div>
      </div>

      <div className="package-room__action-buttons">
        <button className="package-room__submit-button" onClick={onDone}>
          {t('package-room:doorUnlocked.returnToMainScreen')}
        </button>
      </div>
    </div>
  )
}

DoorUnlocked.propTypes = {
  onDone: PropTypes.func.isRequired,
}

export default DoorUnlocked
